import { useEffect, useMemo, useState } from "react";
import oMenu from "o-menu";
import { renderToStaticMarkup } from "react-dom/server";
import { Circle, GeoJSON, Marker, Pane, Polyline, Popup, Rectangle, Tooltip } from "react-leaflet";
import { divIcon, DomEvent } from "leaflet";

import { Card, Stack, Typography } from "@mui/material";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";

import { Box, color } from "@mui/system";
import { changeSelectLocFor, changeSelectLocMode, changeShowAddStationModal, changeShowContext } from "Redux/mapSlice";
import { useDispatch } from "react-redux";
import { OperationNames } from "Types/operation";
import { StationType, IStation } from "Types/station";
import { changeOperation } from "Redux/operationSlice";
import { toggleVisibility as toggleStations } from "Redux/stationsSlice";
import { changeModal } from "Redux/modalSlice";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import Api from "Api";
import { toast } from "react-toastify";
import QueryData from "Constants/QueryData";
import ConfirmModal from "Components/ConfirmModal";
import DeleteStationModal from "../Modals/DeleteStationModal";

const ICON_SIZE = 22;

export default function ContextMenu2() {
  let omenu: any;
  const dispatch = useDispatch();
  const { showContext2, contextPosition2, storedStation } = useAppSelector((state) => state.map);
  const { visible: stationsVisibility } = useAppSelector((state) => state.stations);
  const { path } = useAppSelector((state) => state.app);
  const [activeMenuIndex, setActiveMenuIndex] = useState<null | number>(null);
  const [open, setOpen] = useState<boolean>(false);
  const [selectedItem, setSelectedItem] = useState();
  const [showConfirm, setShowConfirm] = useState<boolean>(false);
  const [stationId, setStationId] = useState<number | null>(null);
  const [stationPaths, setStationPaths] = useState<any[]>([]);
  // const [pivotId, setPivotId] = useState<number>();

  const queryClient = useQueryClient();

  const stationType = () => {
    switch (storedStation.type) {
      case "bus":
        return "directions_bus";
      case "metro":
        return "directions_transit";
      case "taxi":
        return "local_taxi";
      case "train":
        return "train";
      case "bicycle":
        return "pedal_bike";
      case "walking":
        return "directions_walk";
      default:
        break;
    }
  };

  const editStation = (station: IStation) => {
    dispatch(changeModal({ status: "add-station", data: { ...station, isEdit: true } }));
  };

  const handleClickType = (operationName: OperationNames, type: StationType) => {
    dispatch(changeOperation({ name: operationName, type }));

    if (!stationsVisibility) {
      dispatch(toggleStations());
    }
    setActiveMenuIndex(null);
  };

  const handle = (ev: any) => {
    omenu.open("j", {
      slices: [
        {
          data: "editStation",
          content:
            "<div style='text-align:center'><svg class='MuiSvgIcon-root MuiSvgIcon-fontSizeMedium muirtl-8anyod' focusable='false' aria-hidden='true' viewBox='0 0 24 24' data-testid='EditOutlinedIcon'><path d='m14.06 9.02.92.92L5.92 19H5v-.92l9.06-9.06M17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29zm-3.6 3.19L3 17.25V21h3.75L17.81 9.94l-3.75-3.75z'></path></svg></div>",

          styles: {
            defaults: {
              fill: "red",
            },
          },
          slices: [
            {
              content: "mmd",
              styles: {
                defaults: {
                  display: "none",
                },
              },
            },
          ],
        },
        {
          data: "deleteStation",
          content:
            "<div style='text-align:center'><span class='material-icons-outlined notranslate MuiIcon-root MuiIcon-fontSizeMedium muirtl-kp9ftd-MuiIcon-root' aria-hidden='true'>delete</span></div>",

          styles: {
            defaults: {
              fill: "green",
            },
          },
          slices: [
            {
              content: "mmd",
              styles: {
                defaults: {
                  display: "none",
                },
              },
            },
          ],
        },
      ],
    });
  };

  useEffect(() => {
    if (path) {
      omenu = oMenu("main5", {
        menu: {
          firstLevelSliceWidth: 70,
          closeMenuOn: "contextmenu",
          innerCircleRadius: 45,
          innerCircleWidth: 40,
          innerCircleContent: `<div style='text-align:center;margin-top: 30%;'><span class='material-icons-outlined notranslate MuiIcon-root MuiIcon-fontSizeMedium muirtl-kp9ftd-MuiIcon-root' aria-hidden='true'>${stationType()}</span></div>`,
        },
        nthSlice: {
          contentSize: 22,
          iconDistanceFromInnerCircle: 5,
          parentFillMode: -0.3,
          styles: {
            contentContainer: {
              fontSize: 22,
              color: "#efefef",
            },
          },
        },
        slice: {
          onClick: () => console.log("gilam8"),
          contentSize: 30,
          iconDistanceFromInnerCircle: 10,
          styles: {
            contentContainer: {
              fontSize: 30,
              color: "#efefef",
            },
          },
        },
      });
      omenu.on("sliceClick", (ev: any) => {
        if (ev.data === "editStation") {
          editStation(storedStation);
        }
        if (ev.data === "deleteStation") {
          Api.get(`path/station/${storedStation.id}`).then((res: any) => {
            const pathsLength = res.data.Data.station.paths.length;
            if (pathsLength < 2) {
              setShowConfirm(true);
              setStationId(storedStation.id);
            } else {
              setOpen(true);
              setStationPaths(res.data.Data.station.paths);
            }
          });
        }
      });
    }

    if (showContext2) {
      setTimeout(() => handle("j"), 300);
      dispatch(changeShowContext(false));
    }
  }, [showContext2, storedStation]);

  const deleteStation = useMutation({
    mutationFn: () => {
      return Api.delete(`path/station/${stationId}`).then((res) => {
        toast.success("ایستگاه با موفقیت حذف شد");
        setShowConfirm(false);
        queryClient.invalidateQueries({ queryKey: [QueryData.STATION.key] });
      });
    },
  });

  const deleteStationForOnePath = useMutation({
    mutationFn: () => {
      const pivotId = stationPaths.filter((item) => item.id === path?.id)[0]?.pivot?.id;
      return Api.delete(`path/path_station/${pivotId}`).then((res) => {
        toast.success("ایستگاه از این مسیر با موفقیت حذف شد");
        setShowConfirm(false);
        setOpen(false);
        queryClient.invalidateQueries({ queryKey: [QueryData.STATION.key] });
      });
    },
  });

  // deleteStationForOnePath();

  return (
    <>
      <div id="main5" style={{ opacity: "0" }}>
        bfb
      </div>
      <Pane style={{ zIndex: 16 }} name="context-menu-2">
        <Rectangle
          bounds={[
            [0, 0],
            [0, 0],
          ]}
          pathOptions={{ color: "black" }}
          opacity={1}
        >
          <Tooltip offset={[0, 0]} position={contextPosition2} permanent opacity={1}>
            <div id="main5" style={{ pointerEvents: "auto" }} />
          </Tooltip>
        </Rectangle>
      </Pane>
      <ConfirmModal
        open={showConfirm}
        setOpen={setShowConfirm}
        message="ایستگاه انتخاب شده حذف خواهد شد."
        mutation={deleteStation}
      />
      <DeleteStationModal
        isOpen={open}
        setOpen={setOpen}
        stationPaths={stationPaths}
        mutation={deleteStation}
        pathId={path?.id}
        deleteStationForOnePath={deleteStationForOnePath}
      />
    </>
  );
}
